import account from 'Agent/Accounts/ducks/account';
import accountDetails from 'Agent/Accounts/ducks/accountDetail';
import enrollmentApplication from 'Agent/Accounts/ducks/enrollmentApplication';
import a360EnrollmentApplication from 'Agent/Accounts/ducks/a360EnrollmentApplication';
import discrepancySummary from './discrepancySummary';
import invoiceDiscrepancies from './invoiceDiscrepancies';

export default {
  accountDetails,
  account,
  discrepancySummary,
  enrollmentApplication,
  a360EnrollmentApplication,
  invoiceDiscrepancies
};
